import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";
import { validateAndFormatPhone } from "units/utils/formattedPhone";
export const otpReq = async (payload) => {

  try {
    const response = await axiosInstance.post("/auth/customer/otp/request", {
      ...payload
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.data;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      return status;
    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      return {
        ok: false,
        error: {
          message: "مشکل شبکه یا عدم دسترسی به سرور."
        }
      }
    }
  }
};
export const otpForgetPassword = async (payload) => {

  try {
    const response = await axiosInstance.post("/auth/customer/forgot-password", {
      ...payload
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.data;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      return status;
    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      return {
        ok: false,
        error: {
          message: "مشکل شبکه یا عدم دسترسی به سرور."
        }
      }
    }
  }
};
export const otpVerify = async ({ countryCode, phone, otp }) => {
  try {

    const response = await axiosInstance.post("/auth/customer/otp/verify", {
      countryCode,
      phone,
      otp
    });

    return response.data;

  } catch (error) {
    if (error.response) {
      const errorMessage =
        error.response.data?.error ||
        error.response.data?.message ||
        error.message;

      toast.error(errorMessage);

      return error.response.data;
    }

    toast.error("مشکل شبکه یا عدم دسترسی به سرور.");

    return {
      ok: false,
      error: {
        message: "مشکل شبکه یا عدم دسترسی به سرور."
      }
    };
  }
};
export const LoginWithPassword = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/auth/customer/login",
      payload
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }

    return {
      ok: false,
      error: {
        message: "مشکل شبکه یا عدم دسترسی به سرور"
      }
    };
  }
};
export const otpPassVerify = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/auth/customer/password/otp/verify",
      payload
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }

    return {
      ok: false,
      error: {
        message: "مشکل شبکه یا عدم دسترسی به سرور"
      }
    };
  }
};
export const settingSignUpPassword = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/auth/customer/register/complete",
      payload
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }

    return {
      ok: false,
      error: {
        message: "مشکل شبکه یا عدم دسترسی به سرور"
      }
    };
  }
};
